const React = require('react');
const { NavLink: Link } = require('react-router-dom');
const T = require('prop-types');
const { default: Styled } = require('styled-components');

const { default: AppBar } = require('@mui/material/AppBar');
const { default: Toolbar } = require('@mui/material/Toolbar');
const { transient$Props } = require('utils/styles');
const DowntimeDialog = require('containers/DowntimeDialog');
const ForceAppUpgradeDialog = require('containers/ForceAppUpgradeDialog');

const Logomark = require('static/nearpeer_n_white.svg');

const { MAIN_HEADER_HEIGHT } = require('utils/constants');

const FocusIndicator = require('components/FocusIndicator');
const Footer = require('components/Footer');

const { default: Classes } = require('./styles.scss');

const internals = {};

module.exports = function AppBarLayout(props) {

    const {
        children,
        fullWidth,
        hideFooter = false,
        contentWrapperClass,
        topScrollContent,
        bottomScrollContent
    } = props;

    const {
        Wrapper,
        Main,
        StyledToolbar,
        LogoLinkWrapper,
        FooterContainer
    } = internals;

    return (
        <Wrapper
            onFocus={FocusIndicator.onFocusHandler}
            onBlur={FocusIndicator.onBlurHandler}
        >
            <AppBar
                position='fixed'
                style={{ borderRadius: 0 }}
                elevation={0}
            >
                <StyledToolbar>
                    <LogoLinkWrapper to='/'>
                        <div>
                            <img src={Logomark} alt={'Nearpeer logo'} className={Classes.logomark} />
                        </div>
                        <h1
                            id='main-page-heading'
                            tabIndex={0}
                        >
                            Nearpeer
                        </h1>
                    </LogoLinkWrapper>
                </StyledToolbar>
            </AppBar>
            <Main
                $footerShowing={!hideFooter}
                className={`${Classes.main}`}
                onScroll={() => FocusIndicator.wrapFocusIndicatorForElement()}
            >
                {topScrollContent}
                <div className={Classes.mainInnerWrapper}>
                    {/* Main content */}
                    <div style={{ height: '100%' }} className={contentWrapperClass || (fullWidth ? '' : 'contentWrapper')}>
                        {children}
                    </div>
                </div>
                {bottomScrollContent}
                {!hideFooter && (
                    <FooterContainer>
                        <Footer />
                    </FooterContainer>
                )}
                <FocusIndicator />
                <DowntimeDialog />
                <ForceAppUpgradeDialog />
            </Main>
        </Wrapper>
    );
};

module.exports.propTypes = {
    children: T.element.isRequired,
    fullWidth: T.bool,
    hideFooter: T.bool,
    contentWrapperClass: T.string,
    topScrollContent: T.any,
    bottomScrollContent: T.any
};

internals.Wrapper = Styled.div`
    width: 100%;
    height: 100%;
    padding-top: ${MAIN_HEADER_HEIGHT}px;
    display: flex;
    flex-flow: column nowrap;
`;

internals.StyledToolbar = Styled(Toolbar)`
    height: ${MAIN_HEADER_HEIGHT}px;
`;

internals.LogoLinkWrapper = Styled(Link)`
    max-width: 600px;
    margin: auto;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;

    text-decoration: none;

    h1 {
        font-family: 'Mulish', sans-serif;
        font-size: 24px;
        color: white;
    }
`;

internals.Main = Styled('main', transient$Props).attrs({
    id: 'main-content'
})`

    ${({ $footerShowing }) => {

        if ($footerShowing) {
            return `
                margin-bottom: ${MAIN_HEADER_HEIGHT}px;

                @media (max-width: 600px) {
                    margin-bottom: 95px;
                }
            `;
        }

        return 'flex-grow: 1;';
    }}
`;

internals.FooterContainer = Styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
`;
